export const BREEDING_EVENT_TYPE = {
  CALVING: 'Calving'
};

export const BREEDING_STATUSES = [
  'Open',
  'Exposed',
  'Pregnant',
  'Lactating',
  'Dry',
  'Weaned',
  'Aborted',
  'Fattening',
  'Other'
];

export const EVENT_TYPES = [
  'Oestrus Detection',
  'Artificial Insemination',
  'Natural Mating',
  'Embryo Flushing',
  'Embryo Transfer',
  'Pregnancy Diagnosis',
  'Calving',
  'Abortion',
  'Stillbirth',
  'Weaning',
  'Semen Collection',
  'Bull Fertility Test'
];
